export enum LineItemTransactionType {
    purchase = "purchase",
    refund = "refund"
}
